import React, { createContext, useContext, useState, useCallback } from "react";

const translations = {
  nl: {
    "common.loading": "Laden...",
    "common.cancel": "Annuleren",
    "common.credits": "credits",
    "common.balance": "Saldo",
    "common.topUp": "bijkopen",
    "common.save": "Opslaan",

    "title.home": "De wiki waarop je inzet op de waarheid",
    "title.wiki": "De Wiki",
    "title.hof": "Hall of Fame",
    "title.login": "Inloggen",
    "title.register": "Word lid",
    "title.credits": "Koop credits",
    "title.payment": "Betaling",
    "title.mybets": "Mijn inzetten",
    "title.settings": "Instellingen",
    "title.admin": "Redactie",
    "title.notFound": "Artikel niet gevonden",

    "nav.wiki": "Wiki",
    "nav.hof": "Hall of Fame",

    "hof.eyebrow": "Skin in the game",
    "hof.title": "Hall of Fame",
    "hof.subtitle": "Top 100 · gerangschikt op totaal ingezette credits",
    "hof.intro": "Deze Hall of Fame bestaat uit de mensen die hun geld inzetten op hun mening — die letterlijk put their money where their mouth is. Of, zoals Nassim Taleb het noemt: mensen met skin in the game.",
    "hof.note": "Dit betekent geenszins dat zij gelijk hebben. Het betekent dat zij waarde hechten aan hun mening en er ook echt achter staan.",
    "hof.colRank": "#",
    "hof.colName": "Naam",
    "hof.colStaked": "Ingezet",
    "hof.colBets": "Inzetten",
    "hof.staked": "credits ingezet",
    "hof.empty": "Nog niemand in de Hall of Fame. Wees de eerste die skin in the game heeft.",
    "hof.loadError": "Kon de Hall of Fame niet laden",

    "nav.hos": "Hall of Shame",
    "title.hos": "Hall of Shame",

    "hos.eyebrow": "Waardeloze meningen",
    "hos.title": "Hall of Shame",
    "hos.intro": "De mensen in deze Hall of Shame hebben het aanbod gekregen om zonder enig risico put their money where their mouth is — oftewel skin in the game te krijgen in de visie van Nassim Taleb — maar zij weigerden dat.",
    "hos.body": "Volgens professor Bruno de Finetti betekent deze weigering dat hun eigen onderbewustzijn het oneens is met hun bewuste mening: zij staan geenszins achter hun eigen standpunt. Hun mening is daarmee letterlijk waardeloos.",
    "hos.conclusion": "De Finetti stelt dat we mensen die irrationele meningen verkondigen maar weigeren daar geld op te zetten, belachelijk moeten maken. Vandaar deze Hall of Shame.",
    "hos.add": "Toevoegen",
    "hos.addTitle": "Toevoegen aan Hall of Shame",
    "hos.name": "Naam",
    "hos.namePlaceholder": "Naam van de persoon",
    "hos.source": "Bron",
    "hos.sourcePlaceholder": "Link of omschrijving van de bron",
    "hos.reason": "Reden",
    "hos.reasonPlaceholder": "Waarom staat deze persoon hier? (2-3 zinnen)",
    "hos.points": "Punten",
    "hos.pointsPlaceholder": "0",
    "hos.pointsLabel": "punten",
    "hos.editTitle": "Bewerk Hall of Shame-entry",
    "hos.edit": "Bewerken",
    "hos.saved": "Entry bijgewerkt",
    "hos.delayInfo": "Let op: deze persoon verschijnt pas 24 uur na toevoegen publiek op de pagina.",
    "hos.pendingBadge": "Nog niet zichtbaar",
    "hos.visibleFrom": "Zichtbaar vanaf {when}",
    "hos.sourceLabel": "Bron",
    "hos.added": "Toegevoegd aan de Hall of Shame",
    "hos.deleted": "Verwijderd",
    "hos.deleteTitle": "Verwijderen uit Hall of Shame",
    "hos.deleteDesc": "Weet je zeker dat je {name} wilt verwijderen?",
    "hos.empty": "Nog niemand in de Hall of Shame.",
    "hos.loadError": "Kon de Hall of Shame niet laden",
    "hos.fillAll": "Vul alle velden in",


    "nav.editorial": "Redactie",
    "nav.myBets": "Mijn inzetten",
    "nav.settings": "Instellingen",
    "nav.logout": "Uitloggen",
    "nav.login": "Inloggen",
    "nav.register": "Word lid",

    "landing.badge": "Ontmasker de desinformatie",
    "landing.h1a": "Hoe waarschijnlijk is de ",
    "landing.h1accent": "waarheid",
    "landing.intro": "Een encyclopedie van claims, geruchten en beweringen. De redactie bepaalt per artikel hoe waarschijnlijk het is. Jij zet je credits in op de waarheid — hoe onwaarschijnlijker, hoe hoger je uitbetaling.",
    "landing.explore": "Verken de wiki",
    "landing.buyCredits": "Koop credits",
    "landing.bonus": "🎁 Nieuwe leden krijgen €10 gratis om mee te beginnen",
    "landing.howTitle": "Hoe het werkt",
    "landing.howSub": "Van waarschijnlijkheid naar uitbetaling — zonder gedoe.",
    "landing.card1Title": "Lees het dossier",
    "landing.card1Text": "De redactie schrijft artikelen. Titels worden overal automatisch aan elkaar gelinkt tot één web van claims.",
    "landing.card2Title": "De redactie weegt",
    "landing.card2Text": "Elk artikel krijgt een waarschijnlijkheid. Wij vertalen dat naar een uitbetalingsfactor: hoe onwaarschijnlijker, hoe hoger.",
    "landing.card3Title": "Zet je credits in",
    "landing.card3Text": "Koop credits en zet ze in op de waarheid van een artikel. Klopt het? Dan krijg je een veelvoud van je inzet.",
    "landing.market": "Op de markt",
    "landing.all": "Alles",
    "landing.payout": "uitbetaling",
    "landing.discTitle": "Van waarschijnlijkheid naar odds",
    "landing.discText": "Artikelen worden nooit definitief op \"waar\" of \"onwaar\" gezet. Dit platform bestaat om desinformatie te ontmaskeren. Wil je alsnog uitbetaling afdwingen, dan dient dat via de Nederlandse rechter. Credits hebben geen restwaarde.",

    "footer.initiative": "Probably True is een initiatief van TIOUW.com BV, Binderij 7L, 1185 ZH, Amstelveen, Nederland.",

    "wiki.eyebrow": "Het archief",
    "wiki.title": "De Wiki",
    "wiki.sub": "Elke claim heeft een waarschijnlijkheid en een uitbetalingsfactor. Klik door en zet in.",
    "wiki.searchPlaceholder": "Zoek een claim...",
    "wiki.none": "Nog geen artikelen gevonden.",
    "wiki.bets": "inzetten",

    "article.backWiki": "Wiki",
    "article.claimLabel": "Centrale claim",
    "article.videoLabel": "Video",
    "article.notFound": "Artikel niet gevonden",
    "article.backToWiki": "← Terug naar de wiki",
    "article.betTitle": "Zet in op de waarheid van de centrale claim",
    "article.betTitlePrefix": "Zet in op de waarheid van",
    "article.betSub": "Kies één kant. Klik op een bedrag om de inzetters te zien.",
    "article.adminNoBet": "Als redactie kun je hier niet inzetten.",
    "article.agree": "Mee eens",
    "article.disagree": "Oneens",
    "article.staked": "{n} credits ingezet · {c} inzetters →",
    "article.stakedSuffix": "credits ingezet · {c} inzetters →",
    "article.increaseBet": "Verhoog inzet",
    "article.loginToBet": "Log in om in te zetten",
    "article.articleLabel": "Artikel",
    "article.bettorLabel": "Inzetter",
    "article.betDescAgree": "Uitbetalingsfactor {m}× bij deze claim.",
    "article.betDescDisagree": "Geen multiplier — 1× je inzet.",
    "article.noCreditsMsg": "Je kunt nog niet inzetten — je hebt geen credits.",
    "article.buyCredits": "Koop credits",
    "article.howMuch": "Hoeveel wil je inzetten?",
    "article.possiblePayout": "Mogelijke uitbetaling",
    "article.balanceCredits": "Saldo: {c} credits",
    "article.placeBet": "Zet in",
    "article.bettorsSub": "Deze mensen zetten in op \"{side}\".",
    "article.noBettors": "Nog niemand heeft hierop ingezet.",
    "article.invalidStake": "Voer een geldige inzet in",
    "article.betPlaced": "Inzet geplaatst! Je hebt nu skin in the game.",

    "login.eyebrow": "Inloggen",
    "login.title": "Welkom terug",
    "login.email": "E-mail",
    "login.password": "Wachtwoord",
    "login.submit": "Inloggen",
    "login.noAccount": "Nog geen account?",
    "login.join": "Word lid",
    "login.sideTitle": "Terug in het dossier",
    "login.sideText": "Je credits en inzetten wachten op je.",

    "register.eyebrow": "Registreren",
    "register.title": "Word lid",
    "register.bonus": "🎁 Ontvang €10 gratis (10 credits) bij aanmelden",
    "register.name": "Naam",
    "register.email": "E-mail",
    "register.password": "Wachtwoord (min. 6)",
    "register.submit": "Account aanmaken",
    "register.hasAccount": "Al een account?",
    "register.login": "Inloggen",
    "register.sideTitle": "Zet in op de waarheid",
    "register.sideText": "Hoe onwaarschijnlijker de claim, hoe hoger je uitbetaling.",

    "credits.eyebrow": "Wallet",
    "credits.title": "Koop credits",
    "credits.current": "Huidig saldo:",
    "credits.popular": "Populair",
    "credits.available": "Direct beschikbaar",
    "credits.betOnAny": "Inzetten op elk artikel",
    "credits.buy": "Kopen",
    "credits.disclaimer": "Betalingen verlopen veilig via Stripe. Credits hebben geen restwaarde en zijn niet inwisselbaar voor geld. Artikelen worden nooit definitief op waar/onwaar gezet.",
    "credits.termsPre": "Ik ga akkoord met de",
    "credits.termsLink": "algemene voorwaarden",
    "credits.termsRequired": "Ga eerst akkoord met de algemene voorwaarden",

    "payment.checking": "Betaling verifiëren...",
    "payment.checkingSub": "Een moment geduld.",
    "payment.success": "Betaling geslaagd",
    "payment.added": "+{n} credits toegevoegd",
    "payment.goBet": "Ga inzetten",
    "payment.buyMore": "Meer kopen",
    "payment.pending": "Nog in verwerking",
    "payment.pendingSub": "Je credits verschijnen zodra de betaling is bevestigd.",
    "payment.back": "Terug",
    "payment.failed": "Betaling mislukt",
    "payment.failedSub": "Er is iets misgegaan of de sessie is verlopen.",
    "payment.retry": "Opnieuw proberen",

    "admin.eyebrow": "Redactie",
    "admin.title": "Beheer",
    "admin.published": "{n} artikelen gepubliceerd",
    "admin.newArticle": "Nieuw artikel",
    "admin.colTitle": "Titel",
    "admin.colCategory": "Categorie",
    "admin.colProb": "Kans",
    "admin.colFactor": "Factor",
    "admin.colBets": "Inzetten",
    "admin.colActions": "Acties",
    "admin.empty": "Nog geen artikelen. Maak er een aan.",
    "admin.deleteTitle": "Artikel verwijderen?",
    "admin.deleteDesc": "\"{title}\" wordt permanent verwijderd.",
    "admin.delete": "Verwijderen",
    "admin.editTitle": "Artikel bewerken",
    "admin.createTitle": "Nieuw artikel",
    "admin.fieldTitle": "Titel",
    "admin.titlePlaceholder": "bijv. De maan is van kaas",
    "admin.fieldCategory": "Categorie",
    "admin.fieldSummary": "Samenvatting",
    "admin.summaryPlaceholder": "korte intro",
    "admin.fieldClaim": "Centrale claim",
    "admin.claimPlaceholder": "De stelling waar de weddenschap over gaat",
    "admin.claimHint": "Management summary: de exacte claim waarop wordt ingezet. Wordt tussen het plaatje en het artikel getoond.",
    "admin.fieldVideo": "YouTube-video (optioneel)",
    "admin.videoHint": "Plak een YouTube-link. De video wordt netjes ingebed onderaan het artikel.",
    "admin.fieldBody": "Tekst (titels van andere artikelen worden automatisch gelinkt)",
    "admin.fieldSynonyms": "Synoniemen (optioneel)",
    "admin.synonymsPlaceholder": "bijv. NLP, neurolinguïstisch programmeren",
    "admin.synonymsHint": "Komma-gescheiden. Deze termen linken net als de titel automatisch naar dit artikel.",
    "admin.probability": "Waarschijnlijkheid: {p}%",
    "admin.payout": "uitbetaling",
    "admin.probHint": "Onwaarschijnlijk (1%) → hoge uitbetaling · Waarschijnlijk (99%) → lage uitbetaling",
    "admin.publish": "Publiceren",
    "admin.reqTitleBody": "Titel en tekst zijn verplicht",
    "admin.reqBilingual": "Vul titel en tekst in voor beide talen (NL en EN)",
    "admin.image": "Afbeelding",
    "admin.uploadHint": "Klik om een afbeelding te uploaden (max 5MB)",
    "admin.uploading": "Uploaden...",
    "admin.imageUploaded": "Afbeelding geüpload",
    "admin.updated": "Artikel bijgewerkt",
    "admin.created": "Artikel gepubliceerd",
    "admin.deleted": "Artikel verwijderd",

    "bets.eyebrow": "Portfolio",
    "bets.title": "Mijn inzetten",
    "bets.totalStaked": "totaal ingezet",
    "bets.possiblePayout": "mogelijke uitbetaling",
    "bets.empty": "Je hebt nog geen inzetten geplaatst.",
    "bets.explore": "Verken de wiki →",
    "bets.colArticle": "Artikel",
    "bets.colSide": "Kant",
    "bets.colStake": "Inzet",
    "bets.colFactor": "Factor",
    "bets.colPayout": "Uitbetaling",

    "settings.eyebrow": "Account",
    "settings.title": "Instellingen",
    "settings.anonTitle": "Anoniem in de lijsten",
    "settings.anonText": "Als je dit aanzet, verschijn je als \"Anoniem\" in de lijst met inzetters (\"skin in the game\"). Anderen zien je naam dan niet meer.",
    "settings.loggedInAs": "Ingelogd als",
    "settings.anonOn": "Je verschijnt nu anoniem in de lijsten",
    "settings.anonOff": "Je naam is nu zichtbaar",
    "settings.nameTitle": "Je naam",
    "settings.nameText": "Deze naam verschijnt bij je reacties en in de inzetterslijsten (tenzij je anoniem bent).",
    "settings.namePlaceholder": "Je naam",
    "settings.saveName": "Naam opslaan",
    "settings.nameSaved": "Je naam is bijgewerkt",
    "settings.nameEmpty": "Vul een naam in",

    "nav.users": "Gebruikers",

    "stats.title": "Activiteit",
    "stats.creditsBalance": "Huidig saldo",
    "stats.purchased": "Gekochte credits",
    "stats.spent": "Totaal besteed",
    "stats.bets": "Weddenschappen",
    "stats.likes": "Likes gegeven",
    "stats.dislikes": "Dislikes gegeven",
    "stats.comments": "Reacties",

    "adminUsers.eyebrow": "Beheer",
    "adminUsers.title": "Gebruikers",
    "adminUsers.subtitle": "{n} gebruikers",
    "adminUsers.colName": "Naam",
    "adminUsers.colEmail": "E-mail",
    "adminUsers.colCredits": "Saldo",
    "adminUsers.colPurchased": "Gekocht",
    "adminUsers.colBets": "Inzetten",
    "adminUsers.colComments": "Reacties",
    "adminUsers.role": "Redactie",
    "adminUsers.loadError": "Kon gebruikers niet laden",

    "adminUser.back": "← Terug naar gebruikers",
    "adminUser.account": "Account",
    "adminUser.role": "Rol",
    "adminUser.joined": "Lid sinds",
    "adminUser.addCredits": "Credits toevoegen",
    "adminUser.addCreditsTitle": "Credits toevoegen",
    "adminUser.addCreditsDesc": "Hoeveel credits wil je toevoegen aan {name}?",
    "adminUser.amountLabel": "Aantal credits",
    "adminUser.addCreditsSaved": "Credits toegevoegd",
    "adminUser.setPassword": "Wachtwoord instellen",
    "adminUser.setPasswordTitle": "Nieuw wachtwoord instellen",
    "adminUser.setPasswordDesc": "Stel een nieuw wachtwoord in voor {name}. Deel het zelf met de gebruiker.",
    "adminUser.newPassword": "Nieuw wachtwoord (min. 6)",
    "adminUser.setPasswordSaved": "Wachtwoord bijgewerkt",
    "adminUser.invalidAmount": "Voer een geldig aantal in",
    "adminUser.notFound": "Gebruiker niet gevonden",
    "adminUser.delete": "Verwijderen",
    "adminUser.deleteTitle": "Gebruiker verwijderen",
    "adminUser.deleteDesc": "Weet je zeker dat je {name} definitief wilt verwijderen? Dit verwijdert ook hun inzetten, reacties en comments. Dit kan niet ongedaan worden gemaakt.",
    "adminUser.deleted": "Gebruiker verwijderd",


    "comments.title": "Reacties",
    "comments.placeholder": "Schrijf een reactie...",
    "comments.submit": "Plaats reactie",
    "comments.empty": "Nog geen reacties. Wees de eerste!",
    "comments.loginPrompt": "om een reactie te plaatsen.",
    "comments.anonNote": "Je plaatst deze reactie anoniem",
    "comments.delete": "Verwijderen",
    "comments.posted": "Reactie geplaatst",
    "comments.reply": "Antwoorden",
    "comments.replyPlaceholder": "Schrijf een antwoord...",
    "reactions.loginRequired": "Log in om te stemmen",
    "reactions.articlePrompt": "Wat vind jij?",
  },
  en: {
    "common.loading": "Loading...",
    "common.cancel": "Cancel",
    "common.credits": "credits",
    "common.balance": "Balance",
    "common.topUp": "top up",
    "common.save": "Save",

    "title.home": "The wiki where you bet on the truth",
    "title.wiki": "The Wiki",
    "title.hof": "Hall of Fame",
    "title.login": "Log in",
    "title.register": "Join",
    "title.credits": "Buy credits",
    "title.payment": "Payment",
    "title.mybets": "My bets",
    "title.settings": "Settings",
    "title.admin": "Editorial",
    "title.notFound": "Article not found",

    "nav.wiki": "Wiki",
    "nav.hof": "Hall of Fame",

    "hof.eyebrow": "Skin in the game",
    "hof.title": "Hall of Fame",
    "hof.subtitle": "Top 100 · ranked by total credits staked",
    "hof.intro": "This Hall of Fame consists of the people who put their money on their opinion — who literally put their money where their mouth is. Or, as Nassim Taleb calls it: people with skin in the game.",
    "hof.note": "This in no way means they are right. It means they value their opinion and truly stand behind it.",
    "hof.colRank": "#",
    "hof.colName": "Name",
    "hof.colStaked": "Staked",
    "hof.colBets": "Bets",
    "hof.staked": "credits staked",
    "hof.empty": "Nobody in the Hall of Fame yet. Be the first to have skin in the game.",
    "hof.loadError": "Could not load the Hall of Fame",

    "nav.hos": "Hall of Shame",
    "title.hos": "Hall of Shame",

    "hos.eyebrow": "Worthless opinions",
    "hos.title": "Hall of Shame",
    "hos.intro": "The people in this Hall of Shame were offered the chance to put their money where their mouth is at no risk whatsoever — to gain skin in the game in the view of Nassim Taleb — but they refused.",
    "hos.body": "According to professor Bruno de Finetti, this refusal means their own subconscious disagrees with their conscious opinion: they do not stand behind their own position at all. Their opinion is therefore literally worthless.",
    "hos.conclusion": "De Finetti argues that we should ridicule people who proclaim irrational opinions but refuse to put money on them. Hence this Hall of Shame.",
    "hos.add": "Add",
    "hos.addTitle": "Add to Hall of Shame",
    "hos.name": "Name",
    "hos.namePlaceholder": "Name of the person",
    "hos.source": "Source",
    "hos.sourcePlaceholder": "Link or description of the source",
    "hos.reason": "Reason",
    "hos.reasonPlaceholder": "Why is this person here? (2-3 sentences)",
    "hos.points": "Points",
    "hos.pointsPlaceholder": "0",
    "hos.pointsLabel": "points",
    "hos.editTitle": "Edit Hall of Shame entry",
    "hos.edit": "Edit",
    "hos.saved": "Entry updated",
    "hos.delayInfo": "Note: this person only appears publicly on the page 24 hours after being added.",
    "hos.pendingBadge": "Not visible yet",
    "hos.visibleFrom": "Visible from {when}",
    "hos.sourceLabel": "Source",
    "hos.added": "Added to the Hall of Shame",
    "hos.deleted": "Deleted",
    "hos.deleteTitle": "Remove from Hall of Shame",
    "hos.deleteDesc": "Are you sure you want to remove {name}?",
    "hos.empty": "Nobody in the Hall of Shame yet.",
    "hos.loadError": "Could not load the Hall of Shame",
    "hos.fillAll": "Please fill in all fields",


    "nav.editorial": "Editorial",
    "nav.myBets": "My bets",
    "nav.settings": "Settings",
    "nav.logout": "Log out",
    "nav.login": "Log in",
    "nav.register": "Join",

    "landing.badge": "Unmask the disinformation",
    "landing.h1a": "How likely is the ",
    "landing.h1accent": "truth",
    "landing.intro": "An encyclopedia of claims, rumours and assertions. The editorial team sets how likely each article is. You stake your credits on the truth — the less likely, the higher your payout.",
    "landing.explore": "Explore the wiki",
    "landing.buyCredits": "Buy credits",
    "landing.bonus": "🎁 New members get €10 free to get started",
    "landing.howTitle": "How it works",
    "landing.howSub": "From probability to payout — no hassle.",
    "landing.card1Title": "Read the dossier",
    "landing.card1Text": "The editorial team writes articles. Titles are automatically linked everywhere into one web of claims.",
    "landing.card2Title": "The editors weigh in",
    "landing.card2Text": "Every article gets a probability. We translate that into a payout multiplier: the less likely, the higher.",
    "landing.card3Title": "Stake your credits",
    "landing.card3Text": "Buy credits and stake them on the truth of an article. Is it true? Then you get a multiple of your stake.",
    "landing.market": "On the market",
    "landing.all": "All",
    "landing.payout": "payout",
    "landing.discTitle": "From probability to odds",
    "landing.discText": "Articles are never definitively marked \"true\" or \"false\". This platform exists to unmask disinformation. If you still want to enforce a payout, that must go through the Dutch courts. Credits have no residual value.",

    "footer.initiative": "Probably True is an initiative of TIOUW.com BV, Binderij 7L, 1185 ZH, Amstelveen, the Netherlands.",

    "wiki.eyebrow": "The archive",
    "wiki.title": "The Wiki",
    "wiki.sub": "Every claim has a probability and a payout multiplier. Click through and place your bet.",
    "wiki.searchPlaceholder": "Search a claim...",
    "wiki.none": "No articles found yet.",
    "wiki.bets": "bets",

    "article.claimLabel": "Central claim",
    "article.videoLabel": "Video",
    "article.backWiki": "Wiki",
    "article.notFound": "Article not found",
    "article.backToWiki": "← Back to the wiki",
    "article.betTitle": "Bet on the truth of the central claim",
    "article.betTitlePrefix": "Bet on the truth of",
    "article.betSub": "Pick one side. Click an amount to see the bettors.",
    "article.adminNoBet": "As editorial staff you cannot bet here.",
    "article.agree": "Agree",
    "article.disagree": "Disagree",
    "article.staked": "{n} credits staked · {c} bettors →",
    "article.stakedSuffix": "credits staked · {c} bettors →",
    "article.increaseBet": "Increase stake",
    "article.loginToBet": "Log in to place a bet",
    "article.articleLabel": "Article",
    "article.bettorLabel": "Bettor",
    "article.betDescAgree": "Payout multiplier {m}× for this claim.",
    "article.betDescDisagree": "No multiplier — 1× your stake.",
    "article.noCreditsMsg": "You can't bet yet — you have no credits.",
    "article.buyCredits": "Buy credits",
    "article.howMuch": "How much do you want to stake?",
    "article.possiblePayout": "Possible payout",
    "article.balanceCredits": "Balance: {c} credits",
    "article.placeBet": "Place bet",
    "article.bettorsSub": "These people bet on \"{side}\".",
    "article.noBettors": "Nobody has bet on this yet.",
    "article.invalidStake": "Enter a valid stake",
    "article.betPlaced": "Bet placed! You now have skin in the game.",

    "login.eyebrow": "Log in",
    "login.title": "Welcome back",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Log in",
    "login.noAccount": "No account yet?",
    "login.join": "Join",
    "login.sideTitle": "Back in the dossier",
    "login.sideText": "Your credits and bets are waiting for you.",

    "register.eyebrow": "Register",
    "register.title": "Join",
    "register.bonus": "🎁 Get €10 free (10 credits) when you sign up",
    "register.name": "Name",
    "register.email": "Email",
    "register.password": "Password (min. 6)",
    "register.submit": "Create account",
    "register.hasAccount": "Already have an account?",
    "register.login": "Log in",
    "register.sideTitle": "Bet on the truth",
    "register.sideText": "The less likely the claim, the higher your payout.",

    "credits.eyebrow": "Wallet",
    "credits.title": "Buy credits",
    "credits.current": "Current balance:",
    "credits.popular": "Popular",
    "credits.available": "Instantly available",
    "credits.betOnAny": "Bet on any article",
    "credits.buy": "Buy",
    "credits.disclaimer": "Payments are processed securely via Stripe. Credits have no residual value and cannot be exchanged for money. Articles are never definitively marked true/false.",
    "credits.termsPre": "I agree to the",
    "credits.termsLink": "terms and conditions",
    "credits.termsRequired": "Please accept the terms and conditions first",

    "payment.checking": "Verifying payment...",
    "payment.checkingSub": "One moment please.",
    "payment.success": "Payment successful",
    "payment.added": "+{n} credits added",
    "payment.goBet": "Go bet",
    "payment.buyMore": "Buy more",
    "payment.pending": "Still processing",
    "payment.pendingSub": "Your credits will appear once the payment is confirmed.",
    "payment.back": "Back",
    "payment.failed": "Payment failed",
    "payment.failedSub": "Something went wrong or the session expired.",
    "payment.retry": "Try again",

    "admin.eyebrow": "Editorial",
    "admin.title": "Manage",
    "admin.published": "{n} articles published",
    "admin.newArticle": "New article",
    "admin.colTitle": "Title",
    "admin.colCategory": "Category",
    "admin.colProb": "Chance",
    "admin.colFactor": "Factor",
    "admin.colBets": "Bets",
    "admin.colActions": "Actions",
    "admin.empty": "No articles yet. Create one.",
    "admin.deleteTitle": "Delete article?",
    "admin.deleteDesc": "\"{title}\" will be permanently deleted.",
    "admin.delete": "Delete",
    "admin.editTitle": "Edit article",
    "admin.createTitle": "New article",
    "admin.fieldTitle": "Title",
    "admin.titlePlaceholder": "e.g. The moon is made of cheese",
    "admin.fieldCategory": "Category",
    "admin.fieldSummary": "Summary",
    "admin.summaryPlaceholder": "short intro",
    "admin.fieldClaim": "Central claim",
    "admin.claimPlaceholder": "The statement the bet is actually about",
    "admin.claimHint": "Management summary: the exact claim being bet on. Shown between the image and the article.",
    "admin.fieldVideo": "YouTube video (optional)",
    "admin.videoHint": "Paste a YouTube link. The video is embedded neatly at the bottom of the article.",
    "admin.fieldBody": "Text (titles of other articles are auto-linked)",
    "admin.fieldSynonyms": "Synonyms (optional)",
    "admin.synonymsPlaceholder": "e.g. NLP, neuro linguistic programming",
    "admin.synonymsHint": "Comma-separated. These terms auto-link to this article just like the title.",
    "admin.probability": "Probability: {p}%",
    "admin.payout": "payout",
    "admin.probHint": "Unlikely (1%) → high payout · Likely (99%) → low payout",
    "admin.publish": "Publish",
    "admin.reqTitleBody": "Title and text are required",
    "admin.reqBilingual": "Fill in title and text for both languages (NL and EN)",
    "admin.image": "Image",
    "admin.uploadHint": "Click to upload an image (max 5MB)",
    "admin.uploading": "Uploading...",
    "admin.imageUploaded": "Image uploaded",
    "admin.updated": "Article updated",
    "admin.created": "Article published",
    "admin.deleted": "Article deleted",

    "bets.eyebrow": "Portfolio",
    "bets.title": "My bets",
    "bets.totalStaked": "total staked",
    "bets.possiblePayout": "possible payout",
    "bets.empty": "You haven't placed any bets yet.",
    "bets.explore": "Explore the wiki →",
    "bets.colArticle": "Article",
    "bets.colSide": "Side",
    "bets.colStake": "Stake",
    "bets.colFactor": "Factor",
    "bets.colPayout": "Payout",

    "settings.eyebrow": "Account",
    "settings.title": "Settings",
    "settings.anonTitle": "Anonymous in the lists",
    "settings.anonText": "If you enable this, you appear as \"Anonymous\" in the list of bettors (\"skin in the game\"). Others will no longer see your name.",
    "settings.loggedInAs": "Logged in as",
    "settings.anonOn": "You now appear anonymously in the lists",
    "settings.anonOff": "Your name is now visible",
    "settings.nameTitle": "Your name",
    "settings.nameText": "This name appears on your comments and in the bettor lists (unless you are anonymous).",
    "settings.namePlaceholder": "Your name",
    "settings.saveName": "Save name",
    "settings.nameSaved": "Your name has been updated",
    "settings.nameEmpty": "Please enter a name",

    "nav.users": "Users",

    "stats.title": "Activity",
    "stats.creditsBalance": "Current balance",
    "stats.purchased": "Credits purchased",
    "stats.spent": "Total spent",
    "stats.bets": "Bets",
    "stats.likes": "Likes given",
    "stats.dislikes": "Dislikes given",
    "stats.comments": "Comments",

    "adminUsers.eyebrow": "Admin",
    "adminUsers.title": "Users",
    "adminUsers.subtitle": "{n} users",
    "adminUsers.colName": "Name",
    "adminUsers.colEmail": "Email",
    "adminUsers.colCredits": "Balance",
    "adminUsers.colPurchased": "Purchased",
    "adminUsers.colBets": "Bets",
    "adminUsers.colComments": "Comments",
    "adminUsers.role": "Editorial",
    "adminUsers.loadError": "Could not load users",

    "adminUser.back": "← Back to users",
    "adminUser.account": "Account",
    "adminUser.role": "Role",
    "adminUser.joined": "Member since",
    "adminUser.addCredits": "Add credits",
    "adminUser.addCreditsTitle": "Add credits",
    "adminUser.addCreditsDesc": "How many credits do you want to add to {name}?",
    "adminUser.amountLabel": "Number of credits",
    "adminUser.addCreditsSaved": "Credits added",
    "adminUser.setPassword": "Set password",
    "adminUser.setPasswordTitle": "Set a new password",
    "adminUser.setPasswordDesc": "Set a new password for {name}. Share it with the user yourself.",
    "adminUser.newPassword": "New password (min. 6)",
    "adminUser.setPasswordSaved": "Password updated",
    "adminUser.invalidAmount": "Enter a valid amount",
    "adminUser.notFound": "User not found",
    "adminUser.delete": "Delete",
    "adminUser.deleteTitle": "Delete user",
    "adminUser.deleteDesc": "Are you sure you want to permanently delete {name}? This also removes their bets, reactions and comments. This cannot be undone.",
    "adminUser.deleted": "User deleted",


    "comments.title": "Comments",
    "comments.placeholder": "Write a comment...",
    "comments.submit": "Post comment",
    "comments.empty": "No comments yet. Be the first!",
    "comments.loginPrompt": "to post a comment.",
    "comments.anonNote": "You are posting this comment anonymously",
    "comments.delete": "Delete",
    "comments.posted": "Comment posted",
    "comments.reply": "Reply",
    "comments.replyPlaceholder": "Write a reply...",
    "reactions.loginRequired": "Log in to vote",
    "reactions.articlePrompt": "What do you think?",
  },
};

const errorMap = {
  "Onvoldoende credits": "Insufficient credits",
  "Je hebt al op de andere optie ingezet": "You already bet on the other option",
  "E-mailadres is al in gebruik": "Email address is already in use",
  "Onjuiste e-mail of wachtwoord": "Incorrect email or password",
  "De redactie kan niet inzetten": "The editorial team cannot bet",
  "Niet ingelogd": "Not logged in",
  "Artikel niet gevonden": "Article not found",
  "Sessie verlopen": "Session expired",
  "Ongeldig token": "Invalid token",
  "Gebruiker niet gevonden": "User not found",
  "Alleen de admin mag dit doen": "Only the admin can do this",
  "Ongeldig pakket": "Invalid package",
  "Geen refresh token": "No refresh token",
  "Ongeldige optie": "Invalid option",
};

function interpolate(str, params) {
  if (!params) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (params[k] != null ? params[k] : `{${k}}`));
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "nl");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("lang", l);
  }, []);

  const toggleLang = useCallback(() => {
    changeLang(lang === "nl" ? "en" : "nl");
  }, [lang, changeLang]);

  const t = useCallback(
    (key, params) => {
      const dict = translations[lang] || translations.nl;
      return interpolate(dict[key] != null ? dict[key] : key, params);
    },
    [lang]
  );

  const translateError = useCallback(
    (detail) => {
      if (lang === "en" && typeof detail === "string" && errorMap[detail]) return errorMap[detail];
      return detail;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggleLang, t, translateError }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
